var blockquote_default = {
  "fontElementMap": "uvsc3",
  "quoteContainer": "MyvaI",
  "quote": "_9pckA"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
